import { ResponseCertType, ResponseOldCertType } from '../Certificate/types';

// Utility function to check if the response is of type ResponseOldCertType
export function isOldCert(response: ResponseCertType | ResponseOldCertType | null): response is ResponseOldCertType {
  return (response as ResponseOldCertType).format === 'old';
}
